import script from "./Modification.vue?vue&type=script&setup=true&lang=js"
export * from "./Modification.vue?vue&type=script&setup=true&lang=js"

import "./Modification.vue?vue&type=style&index=0&id=4b7f531e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b7f531e"]])

export default __exports__